import React, { useEffect } from "react";
import Navbar from "components/Navbar/navbar";
import FullTestimonials from "components/Full-testimonials/full-testimonials";
import Packslider from "components/Packslider/packSlider";
import Slider from "react-slick";
import { GetTestimonialData } from "components/ApiServices/GetTestimonialsData";
import { useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import LandingPageForm from "components/LandingPageForm/index";
import LoadingScreen from "components/Loading-Screen";
import InfiniteCarousel from "components/Infinite-carousel";
import StaticTestimonials from "components/Static-testimonials/static-testimonials";
import SEO from "components/seo/seo";
import {sendGA4Event} from "common/utils";
import { StaticImage } from "gatsby-plugin-image";

const OneTimeMarketingPack = () => {
  const hideLoader = `.pace,.pace-running,pace-done,pace-inactive,pace-active {
        display:none!important;
    }`;

const handleCallClick = ()=>{
  console.log("hi");
   sendGA4Event("cta_click", {
      cta_name: "Get Free Call Back",
      location: "Hero Section",
    });
}
 
const handleCardClick = (packName) => {

  sendGA4Event("cta_click", {
    cta_name: `Offer - ${packName}`,
    location: "Pricing Section",
  });
};

  return (
    <>
      <style>{hideLoader}</style>
      <section className="ad-heroSec">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="caption center mt-30">
                <h1 className="animate-charcter animated">
                  <span className="main-head">
                    {" "}
                    Elevate Your Brand's Digital Presence{" "}
                  </span>
                
                <span className="subText">
                  {" "}
                  One-Time Social Media Packages Tailored for Success.
                </span>
                </h1>
                <p>
                  Our innovative solutions and expert guidance will fuel your
                  growth journey.
                </p>
                <center>
                  <a
                  onClick={() => handleCallClick()}
                    href="https://calendly.com/evolvan/otsm-package"
                    className="butn curve mt-30 banner-cta"
                   
                  >
                    Get free call back
                  </a>
                </center>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="line left"></div>

      <InfiniteCarousel />

      <div className="line right"></div>

      <section className="services box lficon section-padding position-re one-time-pack sub-bg">
        <div className="container">
          <div className="row justify-content-center ">
            <div className="col-lg-8 col-md-10">
              <div className="sec-head  text-center">
                <h2 className="wow color-font animated">
                  Our one-time pack includes
                </h2>
              </div>
            </div>
          </div>

          <ul id="rev-sec " className="feat mb-30 " >
            <li className="wow fadeInUp about-item-box" data-wow-delay=".2s">
              <img
                className="icon"
                src="../../img/pack-info-icons/Group.webp"
                alt="Group - Social Accounts Creation"
              />
              <h3>Social Accounts Creation</h3>
            </li>

            <li className="wow fadeInUp about-item-box" data-wow-delay=".2s">
              <img
                className="icon"
                src="/img/pack-info-icons/Frame.webp"
                alt="Frame - Customised Templates"
              />
              <h3>Customised Templates</h3>
            </li>
          </ul>

          <ul className="feat mb-30">
            <li className="wow fadeInUp about-item-box" data-wow-delay=".2s">
              <img
                className="icon"
                src="/img/pack-info-icons/Frame(2).webp"
                alt="Frame(2) - Brand Guideline Creation"
              />
              <h3>Brand Guideline Creation</h3>
            </li>

            <li className="wow fadeInUp about-item-box" data-wow-delay=".2s">
              <img
                className="icon"
                src="/img/pack-info-icons/Frame(1).webp"
                alt="Frame(1) - Social Media Audit"
              />
              <h3>Social Media Audit</h3>
            </li>
          </ul>

          <ul className="feat mb-30">
            <li className="wow fadeInUp about-item-box" data-wow-delay=".2s">
              <img
                className="icon"
                src="/img/pack-info-icons/Untitled-2.webp"
                alt="Untitled-2 - Event/Festive Creatives"
              />
              <h3>Event/Festive Creatives</h3>
            </li>

            <li
              className="wow fadeInUp last-about about-item-box"
              data-wow-delay=".2s"
            >
              <h3>and many more....</h3>
            </li>
          </ul>
        </div>
      </section>

      <div className="line left"></div>

      <section
        className="services box lficon section-padding position-re why-use-one-time-pack bg-img"
        style={{ backgroundImage: "url(/img/patrn.svg)" }}
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 col-md-10">
              <div className="sec-head  text-center">
                <h2 className="wow color-font animated">
                  Why use our one-time pack?
                </h2>
              </div>
            </div>
          </div>
           <div className="row">
                    <div className="col-lg-4 col-md-4 wow fadeInLeft" data-wow-delay=".5s">
                        <div className="item-box no-curve">
                            <div className="cont">
                                <h6>1. Cost-Effective Solution</h6>
                                <p>
                                Our one-time pack offers a cost-effective solution compared to ongoing monthly subscriptions, making it suitable for businesses with budget constraints.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-4 wow fadeInLeft" data-wow-delay=".5s">
                        <div className="item-box no-curve">
                            <div className="cont">
                                <h6>2. Tailored to Your Needs</h6>
                                <p>
                                Each one-time pack is custom-tailored to your specific business goals, ensuring that you receive targeted solutions that align with your objectives.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-4 wow fadeInLeft" data-wow-delay=".5s">
                        <div className="item-box no-curve">
                            <div className="cont">
                                <h6>3. Quick Results</h6>
                                <p>
                                With our one-time pack, you can expect to see quick results as we implement strategies designed to boost your online presence efficiently.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-4 wow fadeInLeft" data-wow-delay=".5s">
                        <div className="item-box no-curve">
                            <div className="cont">
                                <h6>4. No Long-Term Commitment</h6>
                                <p>
                                Unlike long-term contracts, our one-time pack requires no long-term commitment, giving you the flexibility to engage with our services as needed.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-4 wow fadeInLeft" data-wow-delay=".5s">
                        <div className="item-box no-curve">
                            <div className="cont">
                                <h6>5. Focused Approach</h6>
                                <p>
                                Our one-time pack allows us to focus our efforts on delivering maximum impact within a specific timeframe, ensuring that your goals are met effectively.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-4 wow fadeInLeft" data-wow-delay=".5s">
                        <div className="item-box no-curve">
                            <div className="cont">
                                <h6>6. Professional Expertise</h6>
                                <p>
                                Benefit from the expertise of our seasoned professionals who will guide you through every step of the process to achieve your desired outcomes.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-4 wow fadeInLeft" data-wow-delay=".5s">
                        <div className="item-box no-curve">
                            <div className="cont">
                                <h6>7. Branded Online Presence</h6>
                                <p>
                                Establish a strong and consistent branded online presence that resonates with your target audience, driving engagement and loyalty.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-4 wow fadeInLeft" data-wow-delay=".5s">
                        <div className="item-box no-curve">
                            <div className="cont">
                                <h6>8. Transparent Process</h6>
                                <p>
                                Our transparent process ensures that you are fully informed and involved throughout the duration of the project, providing peace of mind and confidence in the results
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
        </div>
      </section>

      <div className="line left"></div>

      <StaticTestimonials />

      <div className="line right"></div>

      <section className="pricing-table sub-bg">
        <div className="container price-table d-flex align-items-end justify-content-center flex-wrap">
          <div className="pack-card-container">
            <center>
              <img
                className="pack-icon"
                src="../img/landing-page/pack-info-iconns/Micro-Icon.webp"
                alt="Micro Pack Icon"
              />
            </center>

            <div className="pack-card">
              <div className="price-fetaures">
                <div className="pricing text-center">
                  <h3 className="wow color-font animated">
                    Micro <br /> &#x20b9; 5999
                  </h3>
                </div>

                <div className="features">
                  <h4 className="text-center mb-10">Features</h4>
                  <ul className="list">
                    <li>3 Social Media Accounts</li>
                    <li>Social Media Audit</li>
                    <li>10 Customised Social Media Templates</li>
                    <li>Brand Guidelines Creation</li>
                    <li>10 Festival Creatives</li>
                  </ul>
                </div>
              </div>
              <div className="cont-btn">
                <center>
                  <a href="#contact" className="butn curve banner-cta" 
                  onClick={()=>handleCardClick("Micro")}>
                    Contact US
                  </a>
                </center>
              </div>
            </div>
          </div>

          <div className="pack-card-container">
            <center>
              <img
                className="pack-icon"
                src="../img/landing-page/pack-info-iconns/Hatchback-Icon.webp"
                alt="Hatchback Pack Icon"
              />
            </center>

            <div className="pack-card">
              <div className="price-features">
                <div className="pricing text-center">
                  <h3 className="wow color-font animated">
                    HATCHBACK <br /> &#x20b9; 9999
                  </h3>
                </div>
                <div className="features">
                  <h4 className="text-center mb-10">Features</h4>
                  <ul className="list">
                    <li>Everything in MICRO +</li>
                    <li>5 Social Media Accounts</li>
                    <li>20 Customised Social Media Templates</li>
                    <li>Hashtags Strategy</li>
                    <li>Competitor Analysis</li>
                    <li>Interactive Content Creation</li>
                    <li>20 Festival Creatives</li>
                  </ul>
                </div>
              </div>

              <div className="cont-btn">
                <center>
                  <a href="#contact" className="butn curve banner-cta"
                  onClick={()=>handleCardClick("Hatchback")}>
                    Contact US
                  </a>
                </center>
              </div>
            </div>
          </div>

          <div className="pack-card-container">
            <center>
              <img
                className="pack-icon"
                src="../img/landing-page/pack-info-iconns/Sedan-Icon.webp"
                alt="Sedan Pack Icon"
              />
            </center>
            <div className="pack-card-parent">
              <center>
                <div className="poplr-tag">Most Popular</div>
              </center>
              <div className="pack-card">
                <div className="price-features">
                  <div className="pricing text-center">
                    <h3 className="wow color-font animated">
                      SEDAN <br /> &#x20b9; 12999
                    </h3>
                  </div>
                  <div className="features">
                    <h4 className="text-center mb-10">Features</h4>
                    <ul className="list">
                      <li>Everything in HATCHBACK +</li>
                      <li>10 Social Media Accounts</li>
                      <li>30 Customised Social Media Templates</li>
                      <li>Engagement Boost Tactics</li>
                      <li>Influencer Collaboration Strategy</li>
                      <li>Audience Persona Development</li>
                      <li>Community Building Tactics</li>
                      <li>User-Generated Content Campaign Strategy</li>
                      <li>30 Festival Creatives</li>
                    </ul>
                  </div>
                </div>
                <div className="cont-btn">
                  <center className="mb-20">
                    <a href="#contact" className="butn curve banner-cta"
                   onClick={()=>handleCardClick("Sedan")}>
                      Contact US
                    </a>
                  </center>
                </div>
              </div>
            </div>
          </div>

          <div className="pack-card-container">
            <center>
              <img
                className="pack-icon"
                src="../img/landing-page/pack-info-iconns/SUV-Icon.webp"
                alt="SUV Pack Icon"
              />
            </center>
            <div className="pack-card">
              <div className="price-features">
                <div className="pricing text-center">
                  <h3 className="wow color-font animated">
                    SUV <br /> &#x20b9; 16999
                  </h3>
                </div>
                <div className="features">
                  <h4 className="text-center mb-10">Features</h4>
                  <ul className="list">
                    <li>Everything in SEDAN +</li>
                    <li>Ad Campaign Recommendation</li>
                    <li>Employee Advocacy</li>
                    <li>Live Video Strategy</li>
                    <li>Geotargeting for Local Businesses</li>
                    <li>Storytelling Framework</li>
                  </ul>
                </div>
              </div>

              <div className="cont-btn">
                <center>
                  <a href="#contact" className="butn curve banner-cta"
                   onClick={()=>handleCardClick("SUV")}>
                    Contact US
                  </a>
                </center>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="line left"></div>

      <LandingPageForm />

      <div className="line right"></div>

     <section className="services position-re call-action section-padding sub-bg process">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8 col-md-10">
                            <div className="sec-head  text-center pack-process">
                                <p className="wow fadeIn" data-wow-delay=".5s">How it works</p>
                                <h2 className="wow color-font animated">Our One-Time Pack Process</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-4 col-md-6 col-sm-6  wow fadeInUp d-flex ">
                            <div className="step-item">
                                <h3 className="icon usp-icon">1</h3>
                                <h6>Express Interest</h6>
                                <p>Show interest by filling out our contact form or reaching out to us directly. We'll promptly get in touch with you to discuss your needs and answer any questions you may have.</p>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-6  wow fadeInUp d-flex ">
                            <div className="step-item">
                                <h3 className="icon usp-icon">2</h3>
                                <h6>Package Selection</h6>
                                <p>Choose the package that best suits your requirements from our range of options. Whether you're looking for basic setup or a comprehensive solution, we have packages to fit every need.</p>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-6  wow fadeInUp d-flex ">
                            <div className="step-item">
                                <h3 className="icon usp-icon">3</h3>
                                <h6>Payment</h6>
                                <p>Once you've selected your package, proceed to make the payment securely through our online platform. Rest assured, your transaction is safe and hassle-free.</p>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-6  wow fadeInUp d-flex ">
                            <div className="step-item">
                                <h3 className="icon usp-icon">4</h3>
                                <h6>Strategy Development</h6>
                                <p>With payment confirmed, our team will kickstart the strategy development process. We'll analyze your business, target audience, and competition to create a tailored plan for success.</p>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-6  wow fadeInUp d-flex ">
                            <div className="step-item">
                                <h3 className="icon usp-icon">5</h3>
                                <h6>Brand Guideline Approval</h6>
                                <p>Before we proceed further, we'll present you with brand guidelines and two sample designs for your approval. This ensures that our vision aligns with your expectations and brand identity.</p>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-6 wow fadeInUp d-flex ">
                            <div className="step-item">
                                <h3 className="icon usp-icon">6</h3>
                                <h6>Delivery</h6>
                                <p>Once the brand guidelines are approved, we'll get to work implementing the agreed-upon strategy. Depending on your package, we'll deliver the specified services within the designated timeframe.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

      <div className="line right"></div>

      <section className="clients min-area">
        <div className="content">
          <h2 className="fit-width mx-auto wow color-font animated mb-0">
            Our Trusted Clients
          </h2>
        </div>
        <center>
          <div className="logo-slide">
            <img
              className="grid__img1"
              src="/img/clients-logo/ABC.webp"
              alt="ABC Client Logo"
            />
            <img
              className="grid__img1"
              src="/img/clients-logo/Aura-Finance.webp"
              alt="Aura Finance Client Logo"
            />
            <img
              className="grid__img1"
              src="/img/clients-logo/GK.webp"
              alt="GK Client Logo"
            />
            <img
              className="grid__img1"
              src="/img/clients-logo/kanhiya-ads.webp"
              alt="Kanhiya Ads Client Logo"
            />
            <img
              className="grid__img1"
              src="/img/clients-logo/Mindfull-eating.webp"
              alt="Mindfull Eating Client Logo"
            />
            <img
              className="grid__img1"
              src="/img/clients-logo/Shaxify.webp"
              alt="Shaxify Client Logo"
            />
          </div>
        </center>
      </section>

      <div className="line left"></div>

      <section
        style={{ backgroundImage: "url(/img/patrn.svg)" }}
        className="adfaq-sec bg-img call-action min-area"
      >
        {/* ... unchanged ... */}
      </section>

      <footer className="py-5">
        <p className="text-center">
          &copy; {new Date().getFullYear()} EVOLVAN INFO SOLUTIONS PVT LTD. All
          rights reserved.
        </p>
      </footer>
    </>
  );

}

 export const Head = () => {
    return (
      <SEO
        canonical={`https://evolvan.com/one-time-marketing-pack/`}
        ogimage="https://evolvan.com/img/landing-page/meta-images/Elevate-Your-Brand-s-Digital-Presence-One-Time-Social-Media-Packages-Tailored-for-Success.png"
        title="Elevate Your Brand's Digital Presence: One-Time Social Media Packages Tailored for Success"
        twitterimage="https://evolvan.com/img/landing-page/meta-images/Elevate-Your-Brand-s-Digital-Presence-One-Time-Social-Media-Packages-Tailored-for-Success.png"
      />
    );
  };

export default OneTimeMarketingPack;
